module.exports = __webpack_public_path__ + "assets/img/avatar-9.b2d2893c.jpg";